import { assertArray } from '@/config/helpers.js'

export const getAllSingleProductsOutsideAndInsideGroup = (products) => {
  return assertArray(products).reduce((productList, product) => {
    if (product.products) {
      const formattedProducts = product.products.map((groupProduct) => ({ ...groupProduct, groupName: product.name }))
      productList.push(...formattedProducts)
    } else {
      productList.push(product)
    }

    return productList
  }, [])
}

export const mergeAllIndividualAndGroupProductsByOffer = (offers, groupKeyName) => {
  const products = assertArray(offers).reduce((productList, product) => {
    if (product[groupKeyName]) {
      productList.push(...product[groupKeyName])
    } else {
      productList.push(product)
    }

    return productList
  }, [])

  return products
}

export const mergeAllComboProducts = (tableProducts, groupKeyName) =>
  tableProducts.flatMap((productOrGroup) => productOrGroup?.[groupKeyName] ?? productOrGroup)
